import styled from "styled-components";
import { useState } from "react";
import ProcessStateImage from "../../base/ProcessStateImage";
import ArrowUp from "../../../images/arrow_drop_up.svg";
import ArrowDown from "../../../images/arrow_drop_down.svg";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.headingFontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 3rem;
  line-height: 3.6rem;
  color: #23231f;
  margin: 0;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
    line-height: 2.4rem;
  }
`;

const Text = styled.p`
  text-align: center;
  font-size: 1.6rem;
  line-height: 2.2rem;
  font-weight: 400;
  color: #23231f;
  margin: 0;
`;

const Expand = styled.button`
  border: none;
  background-color: transparent;
  font-size: 1.6rem;
  line-height: 2.2rem;
  font-weight: 500;
  color: #23231f;
  padding: 0;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Toggle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const Arrow = styled.img``;

export interface AuthenticatedText {
  title: string;
  mainText: string;
  expandTitle: string;
  expandText: string;
}

export interface AuthenticatedProps {
  t: AuthenticatedText;
}

export default function Authenticated({ t }: AuthenticatedProps): JSX.Element {
  const [expandDetails, setExpandDetails] = useState<Boolean>(false);

  function arrowDirection(up: Boolean): JSX.Element {
    if (up) return <Arrow src={ArrowUp} />;
    else return <Arrow src={ArrowDown} />;
  }

  return (
    <Container data-testid="authentication_already-authenticated">
      <Title>{t.title}</Title>
      <ProcessStateImage state={{ type: "Authenticated" }} />
      <Text>{t.mainText}</Text>
      <Details>
        <Toggle>
          <Expand onClick={() => setExpandDetails(!expandDetails)}>
            {t.expandTitle}
          </Expand>
          {arrowDirection(expandDetails)}
        </Toggle>

        {expandDetails && <Text>{t.expandText}</Text>}
      </Details>
    </Container>
  );
}
